import { Provider as UserProvider } from 'virtual:tidal-sandbox-list'
import { GlobalControlsProvider, TidalSandboxProvider } from '@workwave-tidal/sandbox-utils'
import { HashRouter } from 'react-router-dom'
import { config } from '../utils/config.js'
import { useSyncRouterToSandboxState } from './atoms/tidalSandboxState.js'
import { useCreateTidalSandboxContext } from './hooks/useCreateTidalSandboxContext.js'
import { Layout } from './Layout.js'

export function Root() {
  return (
    <HashRouter>
      <Providers />
    </HashRouter>
  )
}

export function Providers() {
  const { tidalSandbox, tidalSandboxApi } = useCreateTidalSandboxContext()

  return (
    <TidalSandboxProvider tidalSandbox={tidalSandbox} tidalSandboxApi={tidalSandboxApi}>
      <GlobalControlsProvider>
        <UserProvider config={config}>
          <Content />
        </UserProvider>
      </GlobalControlsProvider>
    </TidalSandboxProvider>
  )
}

function Content() {
  // hack to pass a Router reference to the tidal sandbox store
  useSyncRouterToSandboxState()
  return <Layout />
}
